import {useState, useEffect} from 'react';

import {GroupNode, ApplicationStats} from 'src/types';

import {getGroupingNodes} from '../../api/groups';
import {getApplicationStats} from '../../api/stats';

export const useGroups = (definitionId?: string) => {
  const [groups, setGroups] = useState<GroupNode[] | undefined>();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const loadGroups = async (definitionId?: string) => {
    setLoading(true);
    const response = await getGroupingNodes(null, definitionId || null, {page: 0, pageSize: 100});
    if (response.status === 'success') {
      setLoading(false);
      setGroups(response.data);
    } else {
      setLoading(false);
      setError(true);
      setGroups(undefined);
    }
  };

  useEffect(() => {
    loadGroups(definitionId);
  }, [definitionId]);

  return {groups, loadGroups, loading, error} as const;
};


export const useApplicationStats = (application: GroupNode | null) => {
  const [stats, setStats] = useState<ApplicationStats | undefined>();

  const loadStats = async (id: string) => {
    const {data} = await getApplicationStats({id});
    setStats(data);
  };
  useEffect(() => {
    if (application) {
      loadStats(application.id);
    }
  }, [application]);

  return {stats, loadStats} as const;
};
